import MenuCode from "!!raw-loader!./colorpicker/Default.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";

import Menu from "./colorpicker/Default";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Default", MenuCode, Menu),
	];

	return (
		<Pane
			components={components}
			imports='import ColorPicker from "csi/middleware/lightbox/ColorPicker";'
			{...props}
		/>
	);
};
